/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWorkspaceResponse } from '../../models/create-workspace-response';

export interface DuplicateEmptyWorkspace$Params {

/**
 * Workspace ID
 */
  workspaceId: number;
}

export function duplicateEmptyWorkspace(http: HttpClient, rootUrl: string, params: DuplicateEmptyWorkspace$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateWorkspaceResponse>> {
  const rb = new RequestBuilder(rootUrl, duplicateEmptyWorkspace.PATH, 'post');
  if (params) {
    rb.path('workspaceId', params.workspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateWorkspaceResponse>;
    })
  );
}

duplicateEmptyWorkspace.PATH = '/workspaces/{workspaceId}/duplicate/empty';
